import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotesList } from './notes.model';
import * as dto from './notes-api.model';
import { mapToHttpParams } from '@bcl/common-ui';
import { environment } from 'src/environments';

@Injectable({ providedIn: 'root' })
export class NotesApiService {
  private baseUrl = `${environment.apiHost}/notes`;
  constructor(private http: HttpClient) {}

  public getParentNotes(
    filters: dto.GetParentNotesFilter,
    pageNumber: number,
    pageSize: number
  ): Observable<NotesList> {
    return this.http.get<NotesList>(`${this.baseUrl}/list`, {
      params: mapToHttpParams({ ...filters, pageNumber, pageSize }),
    });
  }

  public addNote(
    newNote: dto.AddNoteRequestDto
  ): Observable<dto.AddNoteResponseDto> {
    return this.http.post<dto.AddNoteResponseDto>(this.baseUrl, newNote);
  }

  public editNote(editNote: dto.EditNoteRequestDto): Observable<void> {
    return this.http.patch<void>(this.baseUrl, editNote);
  }

  public deleteNote(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
